module.exports = __webpack_public_path__ + "media/assets/images/logo-abb98406c030196aab59bcbb117dbd6e.png";